import React from 'react';
import Icon from './Icon';

export default ({ paymentMethod }) => {
    const { brand, last4, exp_month, exp_year, expired } = paymentMethod;
    const iconName = ["amex", "visa", "mastercard", "discover"].includes(brand) ? brand : "creditCard";
    return (
        <>
            <div className='icon-container'>
                <Icon iconName={iconName} width={32} />
            </div>
            <div className='info'>
                <div>{brand.toUpperCase() + ' ...' + last4}</div>
                <div>
                    {expired ? <span className='caption text-error'>Exp: {exp_month}/{exp_year} - EXPIRED</span> : <span className='caption text-muted'>Exp: {exp_month}/{exp_year}</span>}
                </div>
            </div>
        </>
    )
}